import {
  Table,
  TableRow,
  TableCell,
  Paragraph,
  TextRun,
  AlignmentType,
  WidthType,
  BorderStyle,
} from "docx";

export const ModelWorldPopullata = (tableContent) => {
  const docSections = [];

  const createCell = (
    text,
    {
      bold = false,
      color = "000000",
      bgColor = null,
      align = AlignmentType.LEFT,
      borderBottom = true,
      isHeader = false,
      marginTop = 100,
    } = {}
  ) =>
    new TableCell({
      shading: bgColor
        ? {
            type: "clear",
            fill: bgColor,
          }
        : undefined,
      margins: { top: marginTop, bottom: 100, left: 100, right: 100 },
      borders: {
        top: { style: BorderStyle.NONE },
        left: { style: BorderStyle.NONE },
        bottom: borderBottom
          ? { style: BorderStyle.SINGLE, size: 1, color: "CCCCCC" }
          : { style: BorderStyle.NONE },
        right: { style: BorderStyle.NONE },
      },
      width: {
        size: 25,
        type: WidthType.PERCENTAGE,
      },
      children: [
        new Paragraph({
          alignment: align,
          children: [
            new TextRun({
              text,
              bold,
              color,
              size: isHeader ? 20 : 18,
              font: "Arial",
            }),
          ],
        }),
      ],
    });

  let isFirstTable = true;
  let grandTotal = 0; // për totalin e përgjithshëm

  for (const [qarku, rowsData] of Object.entries(tableContent)) {
    const rows = [];

    if (isFirstTable) {
      // Header me marginë më të madhe lart (p.sh. 300)
      rows.push(
        new TableRow({
          children: [
            createCell("Qarku", {
              bold: true,
              color: "FFFFFF",
              bgColor: "e41e26",
              isHeader: true,
              marginTop: 300,
            }),
            createCell("Bashkia", {
              bold: true,
              color: "FFFFFF",
              bgColor: "e41e26",
              isHeader: true,
              marginTop: 300,
            }),
            createCell("Njësia Administrative", {
              bold: true,
              color: "FFFFFF",
              bgColor: "e41e26",
              isHeader: true,
              marginTop: 300,
            }),
            createCell("Popullsia", {
              bold: true,
              color: "FFFFFF",
              bgColor: "e41e26",
              isHeader: true,
              align: AlignmentType.RIGHT,
              marginTop: 300,
            }),
          ],
        })
      );

      isFirstTable = false;
    }

    let total = 0;

    for (const row of rowsData) {
      const popullsia = parseInt(row.Popullsia, 10);
      total += popullsia;
      grandTotal += popullsia;

      rows.push(
        new TableRow({
          children: [
            createCell(row.Qarku),
            createCell(row.Bashkia),
            createCell(row["Njësia Administrative "]),
            createCell(popullsia.toLocaleString("sq-AL"), {
              align: AlignmentType.RIGHT,
            }),
          ],
        })
      );
    }

    // Rreshti i totalit për qarkun
    rows.push(
      new TableRow({
        children: [
          createCell("", { borderBottom: false }),
          createCell("", { borderBottom: false }),
          new TableCell({
            columnSpan: 2,
            shading: {
              type: "clear",
              fill: "f6d7da",
            },
            borders: {
              top: { style: BorderStyle.SINGLE, size: 1, color: "CCCCCC" },
              bottom: { style: BorderStyle.NONE },
              left: { style: BorderStyle.NONE },
              right: { style: BorderStyle.NONE },
            },
            children: [
              new Paragraph({
                alignment: AlignmentType.RIGHT,
                children: [
                  new TextRun({
                    text: `Totali për ${qarku}: `,
                    size: 20,
                    font: "Arial",
                  }),
                  new TextRun({
                    text: total.toLocaleString("sq-AL"),
                    bold: true,
                    color: "e41e26",
                    size: 20,
                    font: "Arial",
                  }),
                ],
              }),
            ],
          }),
        ],
      })
    );

    const table = new Table({
      width: {
        size: 100,
        type: WidthType.PERCENTAGE,
      },
      rows,
      margins: {
        top: 100,
        bottom: 100,
      },
    });

    docSections.push(table);
  }

  // Shtojmë një tabelë me totalin e përgjithshëm në fund
  const totalTable = new Table({
    width: {
      size: 100,
      type: WidthType.PERCENTAGE,
    },
    rows: [
      new TableRow({
        children: [
          createCell("Totali i përgjithshëm i popullsisë:", {
            bold: true,
            color: "FFFFFF",
            bgColor: "e41e26",
            isHeader: true,
            marginTop: 300,
            borderBottom: false,
            align: AlignmentType.RIGHT,
          }),
          new TableCell({
            columnSpan: 3,
            shading: {
              type: "clear",
              fill: "e41e26",
            },
            margins: { top: 300, bottom: 100, left: 100, right: 100 },
            children: [
              new Paragraph({
                alignment: AlignmentType.RIGHT,
                children: [
                  new TextRun({
                    text: grandTotal.toLocaleString("sq-AL"),
                    bold: true,
                    color: "FFFFFF",
                    size: 22,
                    font: "Arial",
                  }),
                ],
              }),
            ],
          }),
        ],
      }),
    ],
    margins: {
      top: 300,
      bottom: 100,
    },
  });

  docSections.push(totalTable);

  return docSections;
};
